import AxiosAdminAPI from "../../../../util/AxiosAdminAPI";
import {V1CapabilityIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";

// Read-only capability list — backs the "grant a capability to a share" picker on an object's
// Visibility tab. Capabilities are AUTHORED in t6, so this reads them straight from t6 through the
// admin API rather than proxying them through a t1 endpoint that would add nothing.
const URL = "t6/v1/capabilities";

class CapabilityEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.Capability-001";

        let QBE = {
            "PlatformMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "Capability": {
                    '_attributes': {'limit': pageSize, 'sort': this.getFormattedSortSpecification(), 'offset': (page - 1) * pageSize},
                    "QueryGroups": {"QueryGroup": [{"Name": "primary", "Operator": "AND", "Type": "QueryGroup", "Membership": {"Member": []}}]}
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;
                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) operator = queryPayload.get(key + "_query");
                QBE.PlatformMessage.Capability.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute", "Name": key, "Value": value, "Operator": operator
                })
            }
        }

        AxiosAdminAPI({
            method: "GET",
            url: URL,
            json: true,
            params: {"QBE": btoa(JSON.stringify(QBE))},
            headers: {"idoc-response": idocResponse},
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1CapabilityIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default CapabilityEnterpriseComponent;
